import { useState } from 'react';
import { Card, Table, Input, Badge } from '@nexora/design-system';

interface CstEntry {
  code: string;
  description: string;
  taxType: 'ICMS' | 'PIS/COFINS' | 'IPI';
}

const CST_DATA: CstEntry[] = [
  // ICMS
  { code: '00', description: 'ICMS integralmente tributado', taxType: 'ICMS' },
  { code: '10', description: 'ICMS tributado e com cobrança por ST', taxType: 'ICMS' },
  { code: '20', description: 'ICMS com redução de base de cálculo', taxType: 'ICMS' },
  { code: '30', description: 'ICMS isento ou não tributado, com cobrança por ST', taxType: 'ICMS' },
  { code: '40', description: 'ICMS isento', taxType: 'ICMS' },
  { code: '41', description: 'ICMS não tributado', taxType: 'ICMS' },
  { code: '50', description: 'ICMS suspenso', taxType: 'ICMS' },
  { code: '51', description: 'ICMS diferido', taxType: 'ICMS' },
  { code: '60', description: 'ICMS cobrado anteriormente por ST', taxType: 'ICMS' },
  { code: '70', description: 'ICMS com redução de base e ST', taxType: 'ICMS' },
  { code: '90', description: 'ICMS outras', taxType: 'ICMS' },
  { code: '101', description: 'ICMS ST - tributado monofásico', taxType: 'ICMS' },
  { code: '102', description: 'ICMS ST - isento monofásico', taxType: 'ICMS' },
  { code: '103', description: 'ICMS ST - não tributado monofásico', taxType: 'ICMS' },
  { code: '201', description: 'ICMS ST - tributado monofásico com ST', taxType: 'ICMS' },
  { code: '202', description: 'ICMS ST - isento monofásico com ST', taxType: 'ICMS' },
  { code: '203', description: 'ICMS ST - não tributado monofásico com ST', taxType: 'ICMS' },
  { code: '300', description: 'ICMS imune', taxType: 'ICMS' },
  { code: '400', description: 'ICMS não incidente', taxType: 'ICMS' },
  { code: '500', description: 'ICMS com cobrança de ICMS por substituição tributária', taxType: 'ICMS' },
  { code: '900', description: 'ICMS outros', taxType: 'ICMS' },
  // PIS/COFINS
  { code: '01', description: 'Operação tributável (base de cálculo = valor operacional)', taxType: 'PIS/COFINS' },
  { code: '02', description: 'Operação tributável (base de cálculo = valor operacional - alíquota diferenciada)', taxType: 'PIS/COFINS' },
  { code: '03', description: 'Operação tributável (base de cálculo = quantidade)', taxType: 'PIS/COFINS' },
  { code: '04', description: 'Operação tributável (tributação monofásica)', taxType: 'PIS/COFINS' },
  { code: '05', description: 'Operação tributável (substituição tributária)', taxType: 'PIS/COFINS' },
  { code: '06', description: 'Operação tributável (alíquota zero)', taxType: 'PIS/COFINS' },
  { code: '07', description: 'Operação isenta', taxType: 'PIS/COFINS' },
  { code: '08', description: 'Operação sem incidência', taxType: 'PIS/COFINS' },
  { code: '09', description: 'Operação suspensa', taxType: 'PIS/COFINS' },
  { code: '49', description: 'Outras operações de saída', taxType: 'PIS/COFINS' },
  { code: '50', description: 'Operação com direito a crédito', taxType: 'PIS/COFINS' },
  { code: '51', description: 'Operação com direito a crédito (diferenciada)', taxType: 'PIS/COFINS' },
  { code: '52', description: 'Operação com direito a crédito (monofásica)', taxType: 'PIS/COFINS' },
  { code: '53', description: 'Operação com direito a crédito (substituição)', taxType: 'PIS/COFINS' },
  { code: '54', description: 'Operação com direito a crédito (alíquota zero)', taxType: 'PIS/COFINS' },
  { code: '55', description: 'Operação com direito a crédito (isenção)', taxType: 'PIS/COFINS' },
  { code: '56', description: 'Operação com direito a crédito (não incidência)', taxType: 'PIS/COFINS' },
  { code: '60', description: 'Crédito presumido', taxType: 'PIS/COFINS' },
  { code: '61', description: 'Crédito presumido (diferenciada)', taxType: 'PIS/COFINS' },
  { code: '62', description: 'Crédito presumido (monofásica)', taxType: 'PIS/COFINS' },
  { code: '63', description: 'Crédito presumido (substituição)', taxType: 'PIS/COFINS' },
  { code: '64', description: 'Crédito presumido (alíquota zero)', taxType: 'PIS/COFINS' },
  { code: '65', description: 'Crédito presumido (isenção)', taxType: 'PIS/COFINS' },
  { code: '66', description: 'Crédito presumido (não incidência)', taxType: 'PIS/COFINS' },
  { code: '67', description: 'Crédito presumido (outras)', taxType: 'PIS/COFINS' },
  { code: '70', description: 'Operação de aquisição sem direito a crédito', taxType: 'PIS/COFINS' },
  { code: '71', description: 'Operação de aquisição sem direito a crédito (diferenciada)', taxType: 'PIS/COFINS' },
  { code: '72', description: 'Operação de aquisição sem direito a crédito (monofásica)', taxType: 'PIS/COFINS' },
  { code: '73', description: 'Operação de aquisição sem direito a crédito (substituição)', taxType: 'PIS/COFINS' },
  { code: '74', description: 'Operação de aquisição sem direito a crédito (alíquota zero)', taxType: 'PIS/COFINS' },
  { code: '75', description: 'Operação de aquisição sem direito a crédito (isenção)', taxType: 'PIS/COFINS' },
  { code: '98', description: 'Outras operações de entrada', taxType: 'PIS/COFINS' },
  { code: '99', description: 'Outras operações', taxType: 'PIS/COFINS' },
  // IPI
  { code: '00', description: 'IPI tributado (alíquota normal)', taxType: 'IPI' },
  { code: '01', description: 'IPI tributado (alíquota reduzida)', taxType: 'IPI' },
  { code: '02', description: 'IPI isento', taxType: 'IPI' },
  { code: '03', description: 'IPI não tributado', taxType: 'IPI' },
  { code: '04', description: 'IPI suspenso', taxType: 'IPI' },
  { code: '05', description: 'IPI com redução de base', taxType: 'IPI' },
  { code: '49', description: 'IPI outras', taxType: 'IPI' },
  { code: '50', description: 'IPI tributado - entrada', taxType: 'IPI' },
  { code: '51', description: 'IPI tributado - entrada (reduzida)', taxType: 'IPI' },
  { code: '52', description: 'IPI isento - entrada', taxType: 'IPI' },
  { code: '53', description: 'IPI não tributado - entrada', taxType: 'IPI' },
  { code: '99', description: 'IPI outras - entrada', taxType: 'IPI' },
];

export function CstTablesPage(): JSX.Element {
  const [activeTab, setActiveTab] = useState<'ICMS' | 'PIS/COFINS' | 'IPI'>('ICMS');
  const [search, setSearch] = useState('');

  const tabs: Array<{ key: typeof activeTab; label: string }> = [
    { key: 'ICMS', label: 'ICMS' },
    { key: 'PIS/COFINS', label: 'PIS/COFINS' },
    { key: 'IPI', label: 'IPI' },
  ];

  const filtered = CST_DATA
    .filter(c => c.taxType === activeTab)
    .filter(c => !search || c.code.includes(search) || c.description.toLowerCase().includes(search.toLowerCase()));

  const columns = [
    { header: 'CST', accessor: 'code' as const, render: (v: string) => <code style={{ fontWeight: 600, fontSize: '1rem' }}>{v}</code> },
    { header: 'Descrição', accessor: 'description' as const },
  ];

  return (
    <div className="fiscal-page">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-md mb-lg">
        <div>
          <h1 className="font-display-lg text-display-lg text-on-surface m-0">Tabelas CST</h1>
          <p className="font-body-md text-body-md text-on-surface-variant mt-xs">Códigos de Situação Tributária por tributo.</p>
        </div>
        <div className="flex flex-wrap items-center gap-sm">
          <p style={{ color: '#43474e', fontSize: '0.875rem' }}>Códigos de Situação Tributária</p>
        </div>
      </div>
      <Card>
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
              <Badge variant="info">{CST_DATA.filter(c => c.taxType === tab.key).length}</Badge>
            </button>
          ))}
        </div>
        <div className="filters">
          <Input placeholder="Buscar por código ou descrição..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <Table columns={columns} data={filtered} emptyMessage="Nenhum CST encontrado" />
      </Card>
      <style>{`
        .fiscal-page { padding: 1.5rem; }
        .tabs { display: flex; gap: 0.5rem; margin-bottom: 1rem; border-bottom: 1px solid #e0e3e5; padding-bottom: 0; }
        .tab { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 1rem; border: none; background: none; cursor: pointer; font-size: 0.875rem; color: #43474e; border-bottom: 2px solid transparent; }
        .tab.active { color: #002045; border-bottom-color: #002045; font-weight: 600; }
        .filters { margin-bottom: 1rem; }
      `}</style>
    </div>
  );
}
